export * from "./building";

import { BuildingComponent } from "./building";

export const BuildingOrganisms = [BuildingComponent];
